export default {
  default: () => import("/usr/src/app/layouts/Default.vue")
}